module.exports = __webpack_public_path__ + "img/SL7_4561-Bearbeitet.0af73b9e.jpg";